import store from "../store/index";

export function isNotAuth(to, from, next) {
  if (store.getters.loggedIn) {
    next("/");
  } else next();
}
